<div class="time-container">
  <button class="time-button" (click)="adjust(-step)">
    <span inlineSVG="/icons/icon-chevron-down.svg" class="arrow-icon left"> </span
    ><span class="adjust adjust-down-value">-{{ step }}</span>
  </button>

  <input #timeInput class="time-display" [value]="getFormattedTime()" (blur)="validateAndSet(); onTouched()" />

  <button class="time-button" (click)="adjust(step)">
    <span class="adjust adjust-up-value">+{{ step }}</span
    ><span inlineSVG="/icons/icon-chevron-down.svg" class="arrow-icon right"> </span>
  </button>
</div>
